import React, { Fragment, useCallback, useState, useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import StatusBanner from '@ringcentral/rcv-ui/src/components/StatusBanner';

export const withAnimatedBanner = (Component, lifeTime = 3000, animationDuration = 1000) =>
    function BannerWrapper(props) {
        const bannerTO = useRef(null);
        const [banner, setBanner] = useState(null);
        const [isBannerShown, setIsBannerShown] = useState(false);

        useEffect(() => {
            if (banner) {
                setIsBannerShown(true);
                clearTimeout(bannerTO.current);
                bannerTO.current = setTimeout(() => {
                    setIsBannerShown(false);
                    bannerTO.current = null;
                }, lifeTime);
            }

            return () => {
                clearTimeout(bannerTO.current);
            };
        }, [banner]);

        const showBanner = useCallback(banner => {
            setBanner(banner);
        }, []);

        return (
            <Fragment>
                <CSSTransition
                    in={isBannerShown}
                    timeout={animationDuration}
                    classNames='banner-transitions'
                    unmountOnExit={true}>
                    <StatusBanner className='no-mobile-view' banner={banner} />
                </CSSTransition>
                <Component {...props} showBanner={showBanner} />
            </Fragment>
        );
    };
